module.exports = __webpack_public_path__ + "static/media/64.492fe0b8.wav";